
// src/api/designation.ts
import { apiClient } from "../helpers/api_helper";

export interface Designation {
    id: number;
    title: string;
    description?: string;
    status: boolean;
    created_at: string;
    updated_at: string;
}

export const fetchDesignations = async (includeInactive: boolean = false) => {
    const response = await apiClient.get(`/designations?include_inactive=${includeInactive}`);
    return response.data;
};